<input #addresstext class="form-control" type="text" [formControl]="autocompleteInput" (input)="inputChanged(autocompleteInput.value)">